(async function(){

  // The purpose of this function is to get an array of all columns in the manifest.
  // Some rows have missing columns, but the same relative order of columns is respected in all rows.
  // We want the final array of columns to respect this relative order.
  function getAllManifestColumns( manifestRows ) {

    // get an array of columns in each row. Each array is sorted in object insertion order
    const columnsByRow = manifestRows.map( row => Object.keys( row ) );

    const sortedColumns = JSON.parse( JSON.stringify( columnsByRow[0] ) );

    // iterate over each row
    for( let i = 1; i < columnsByRow.length; i++ ) {

      // iterate over each column in the current row
      for( let j = 0; j < columnsByRow[i].length; j++ ) {

        const column = columnsByRow[i][j];

        // if the current column has not yet been added to the sortedColumns array
        if( !sortedColumns.includes( column ) ) {

          // Now we find where to insert the current column.
          // Working backwards from the position of the current column in the current row,
          // find the first column that is also in the sortedColumns array.
          // After the loop breaks idx will have the index (in sortedColumns array) of the first column found,
          // or -1 if no column is found and the loop terminates.
          let idx;
          for( let k = j-1; k >= 0; k-- ) {

            idx = sortedColumns.indexOf( columnsByRow[i][k] );

            if( idx > -1 ) {

              break;

            }

          }
          // insert the current column after the index found in the previous loop.
          // Note that if no column is found, the current column is inserted at the beginning of the array.
          sortedColumns.splice( idx+1, 0, column );

        }

      }

    }

    return sortedColumns;
  }

  async function fetchManifestJson( url ) {
    try {
      const response = await fetch( url );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching JSON:', error);
    }
  }

  async function setProductManifestJson( product ) {

    try {

      const productManifestJsonScriptTag = document.querySelector( 'script[type=ninja-product-manifest-json]' );
      product.manifestJson = productManifestJsonScriptTag ? JSON.parse( productManifestJsonScriptTag.innerHTML ) : null;

    }
    catch(e) {
      console.log(`No embedded product manifest json for ${product.handle}.`);
    }

    if( !product.manifestJson && product.manifestJsonLocation ) {

      try {
        product.manifestJson = await fetchManifestJson( product.manifestJsonLocation );
      }
      catch(e) {
        console.log(`No valid product manifest json file for ${product.handle}.`);
      }

    }

  }

  async function setManifestColumnar( product ) {
    if(!product) {
      return;
    }

    await setProductManifestJson( product );

    if( !product.manifestJson ) {
      return;
    }

    const columnNames = getAllManifestColumns( product.manifestJson );

    if(columnNames.length) {
      const table = document.querySelector('[data-ninja="manifest-table-columnar"]');
      const tableHead = document.createElement('thead');
      table.append( tableHead );

      const headerRow = document.createElement('tr');
      for( const name of columnNames ) {
        const headerItem = document.createElement('th');
        headerItem.innerHTML = `<span class="header-title">${name}</span>`;
        headerRow.append( headerItem );
      }
      tableHead.append( headerRow );

      const tbody = document.createElement('tbody');
      table.append( tbody );

      for( const item of product.manifestJson ) {

        const row = document.createElement('tr');

        for( const columnName of columnNames ) {

          const tableCell = document.createElement('td');
          tableCell.classList.add('ninja__product-manifest__table-cell');

          if( columnName.match(/image/i) ) {
            if( item[columnName] ) {
              const imgUrl = Array.isArray(item[columnName]) ? item[columnName][0] : item[columnName];
              if( imgUrl ) {
                tableCell.innerHTML = `<a href="${imgUrl}" target="_blank" rel="noreferrer noopener"><img class="ninja__product-manifest__table-cell__image" src="${imgUrl}"/></a>`;
              }
            }
          }
          else if( columnName.match(/asin/i) ) {
            const asin = item[columnName];
            if( asin ) {
              const linkUrl = `https://www.amazon.com/dp/${ asin }`;
              tableCell.innerHTML = `<a href="${linkUrl}" class="ninja__product-manifest__table-cell__asin-link" target="_blank" rel="noreferrer noopener">${asin}</a>`;
            }
          }
          else if( columnName.match(/price/i) ) {
            const price = parseFloat( item[columnName] );
            if( price ) {
              tableCell.innerHTML = FoxTheme.Currency.formatMoney( price * 100, FoxTheme.settings.moneyFormat );
            }
          }
          else {
            tableCell.innerHTML = item[columnName] || '';
          }

          row.append( tableCell );

        }

        tbody.append( row );

      }
    }

  }

  const transposedTableHeaders = [
    {
      key: 'title',
      displayName: '',
      columnName: 'Description',
    },
    {
      key: 'upc',
      displayName: 'Barcode',
      columnName: 'UPC/EAN/GTIN',
    },
    {
      key: 'asin',
      displayName: 'ASIN',
      columnName: 'ASIN',
    },
    {
      key: 'brand',
      displayName: 'Brand',
      columnName: 'Brand',
    },
    {
      key: 'price',
      displayName: 'Unit Price',
      columnName: 'Unit Price',
    },
    {
      key: 'quantity',
      displayName: 'Quantity',
      columnName: 'Quantity',
    },
  ];

  function initDescriptionClampToggle( desc ) {

    if( desc.parentElement && desc.scrollHeight > desc.clientHeight ) {

      const toggle = document.createElement('span');
      toggle.classList.add('ninja__product-manifest__description-toggle');
      toggle.textContent = '… show more';
      toggle.addEventListener('click', () => {
        const expanded = desc.classList.toggle('expanded');
        toggle.textContent = expanded ? 'show less' : '… show more';
      });
      desc.parentElement.append( toggle );

    }
    
  }

  async function setManifestTransposed( product ) {
    if(!product) {
      return;
    }

    await setProductManifestJson( product );

    if( !product.manifestJson ) {
      return;
    }


    const columnNames = getAllManifestColumns( product.manifestJson );

    if( columnNames.length ) {

      const rows = {};
      for( let header of transposedTableHeaders.filter( $ => columnNames.includes( $.columnName ) ) ) {
        const row = document.createElement('tr');
        const th = document.createElement('th');
        th.classList.add(`ninja__product-manifest__table-header-cell`);
        th.classList.add(`ninja__product-manifest__table-header-cell__${ header.key }`);
        th.setAttribute( 'scope', 'row' );
        th.innerHTML = `<span>${ header.displayName }</span>`;
        row.append(th);
        rows[ header.key ] = row;
      }

      const table = document.querySelector('[data-ninja="manifest-table-transposed"]');

      const tbody = document.createElement('tbody');
      table.append( tbody );

      for( const item of product.manifestJson ) {
        if( rows['title'] ) {
          const titleCell = document.createElement('td');
          rows['title'].append( titleCell );
          if( item["Image"] ) {
            const imgUrl = Array.isArray(item["Image"]) ? item["Image"][0] : item["Image"];
            if( imgUrl ) {
              const a = document.createElement('a');
              a.href = imgUrl;
              a.target = "_blank";
              a.rel = "noreferrer noopener";
              a.innerHTML = `<img class="ninja__product-manifest__table-cell__image" src="${imgUrl}"/>`;
              titleCell.append( a );
            }
          }
          if( item['Description'] ) {

            const container = document.createElement('div');
            container.classList.add('ninja__product-manifest__description-container');
            titleCell.append( container );

            const desc = document.createElement('p');
            desc.classList.add('ninja__product-manifest__description');
            desc.innerHTML = item['Description'] || '';
            container.append( desc );

          }
        }

        if( rows['upc'] ) {
          const upcCell = document.createElement('td');
          rows['upc'].append( upcCell );
          upcCell.innerHTML = item['UPC/EAN/GTIN'] || '';
        }

        if( rows['asin'] ) {
          const asinCell = document.createElement('td');
          rows['asin'].append( asinCell );
          const asin = item['ASIN'];
          if( asin ) {
            const linkUrl = `https://www.amazon.com/dp/${ asin }`;
            asinCell.innerHTML = `<a href="${linkUrl}" class="ninja__product-manifest__table-cell__asin-link" target="_blank" rel="noreferrer noopener">${asin}</a>`;
          }
        }

        if( rows['brand'] ) {
          const brandCell = document.createElement('td');
          rows['brand'].append( brandCell );
          brandCell.innerHTML = item['Brand'] || '';
        }

        if( rows['price'] ) {
          const priceCell = document.createElement('td');
          rows['price'].append( priceCell );
          const price = parseFloat( item['Unit Price'] );
          if( price ) {
            priceCell.innerHTML = FoxTheme.Currency.formatMoney( price * 100, FoxTheme.settings.moneyFormat );
          }
        }

        if( rows['quantity'] ) {
          const quantityCell = document.createElement('td');
          rows['quantity'].append( quantityCell );
          quantityCell.innerHTML = item['Quantity'] || '';
        }

      }

      for( const row of Object.values(rows) ) {
        tbody.append( row );
      }
    }

    const descs = document.querySelectorAll('.ninja__product-manifest__description');
    for( let desc of descs ) {
      if( document.readyState !== 'loading' ) {
        initDescriptionClampToggle( desc );
      }
      else {
        document.addEventListener( 'DOMContentLoaded', () => {
          console.log('DOMContentLoaded')
          initDescriptionClampToggle( desc );
        } );
      }
    }

  }

  // await setManifestColumnar( Ninja.mainProduct );
  await setManifestTransposed( Ninja.mainProduct );

})();
